<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mt-4"
        style="color: #23468c; font-weight: 500"
      >
        Search SKU Variant
      </div>
      <v-spacer></v-spacer>
      <v-col
        cols="12"
        sm="3"
        class="pb-0 pt-0 pr-0"
        :class="{ 'mr-8': result.length > 0 }"
        v-if="
          userCategory.user_category === 3 || userCategory.user_category === 6
        "
      >
        <v-autocomplete
          v-model="client"
          :items="clients"
          dense
          item-text="name"
          item-value="id"
          label="Select Client"
          class="required pb-0 pt-0"
          @change="getStores(client)"
          @focus="fetchClientList"
          :rules="[(v) => !!v || 'Client is required.']"
          outlined
        ></v-autocomplete>
      </v-col>
    </div>
    <v-divider
      class="mt-1 mb-4"
      :class="{ 'mr-8': result.length > 0 }"
    ></v-divider>
    <v-dialog v-model="dialog" max-width="400" max-height="500">
      <v-card>
        <v-card-title class="card-title">
          Mapped Images- {{ selectedItem.variant_sku_code }}-({{
            selectedItem.sku_code
          }})
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-carousel
            cycle
            hide-delimiters
            interval="5000"
            show-arrows-on-hover
            height="200"
            v-if="images && images.length > 1"
          >
            <v-carousel-item
              v-for="(image, index) in images"
              :key="index"
              :src="image"
              max-height="200"
              class="carousel-image"
              contain
            ></v-carousel-item>
          </v-carousel>
          <v-img v-else :src="images[0]"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="loader-wrapper" :class="{ active: isloading }" v-if="isloading">
      <div class="loader" v-if="isloading"></div>
    </div>
    <v-card-text class="pl-0 pr-0 pt-0 mr-8">
      <v-card
        class="pl-4 pr-4 pb-2 pt-4"
        :class="{ 'mr-8': result.length > 0 }"
      >
        <v-form ref="form" @submit.prevent="getlist" type="submit">
          <v-row>
            <v-col cols="12" sm="3" class="pb-0">
              <v-autocomplete
                v-model="infor_storer_id"
                label="Storer Name"
                :rules="[(v) => !!v || 'Storer Name is required.']"
                item-text="channel_name"
                item-value="id"
                class="required"
                dense
                :items="stores"
                @change="getSkuDropDownList"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field
                outlined
                v-model="sku"
                dense
                label="SKU"
                :rules="[(v) => (v && !!v.trim()) || 'SKU is required.']"
                class="required"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              class="pl-0"
              sm="6"
              :class="
                userCategory.user_category === 3 ||
                userCategory.user_category === 6
                  ? ''
                  : ''
              "
            >
              <v-btn color="success" :loading="loader" @click="getlist"
                >Search</v-btn
              >
              <v-btn
                color="primary"
                :loading="loader"
                @click="$router.push('add-edit-sku/0')"
                class="ml-1"
                v-if="checkPermission('app_sku_variant:b2b_sku_variant_create')"
                >Add SKU Variant</v-btn
              >
              <v-btn
                color="info"
                :loading="loader"
                @click="$router.push('linksku')"
                v-if="
                  checkPermission('app_sku_variant:b2b_sku_image_link_unlink')
                "
                class="ml-1"
                >Upload Image</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-card-text>

    <v-data-table
      :headers="headers"
      :items="result"
      item-key="name"
      class="elevation-1"
      :class="{ 'mr-8': result.length > 0 }"
      :single-expand="true"
      disable-pagination
      hide-default-footer
      v-if="result.length > 0"
    >
      <template v-slot:top>
        <v-divider class="my-2"></v-divider>
      </template>
      <template v-slot:item.images="{ item }">
        <v-carousel
          cycle
          hide-delimiters
          interval="5000"
          show-arrows-on-hover
          height="100"
          width="400"
          v-if="item.images && item.images.length > 1"
        >
          <v-carousel-item
            v-for="(image, index) in item.images"
            :key="index"
            :src="image"
            :alt="image.alt"
            max-height="100"
            max-width="400"
            class="carousel-image"
            contain
          ></v-carousel-item>
        </v-carousel>
        <span v-else>
          <v-img
            v-if="item.images && item.images.length > 0"
            :src="item.images[0]"
          ></v-img>
        </span>
      </template>
    </v-data-table>
    <v-data-table
      :headers="headersChild"
      :items="resultChild"
      :options.sync="options"
      item-key="name"
      :class="{ 'mr-8': resultChild.length > 0 }"
      class="elevation-1 mt-1"
      :single-expand="true"
      :server-items-length="total"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      v-if="resultChild.length > 0"
    >
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">{{
          item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span
        ><br />
        <span v-if="item.created_by"> ({{ item.created_by }})</span>
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at">{{
          item.updated_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span
        ><br /><span v-if="item.updated_by"> ({{ item.updated_by }})</span>
      </template>
      <template v-slot:[`item.size`]="{ item }">
        {{
          (item.size ? item.size : "-") +
          " / " +
          (item.design ? item.design : "-") +
          " / " +
          (item.aroma ? item.aroma : "-")
        }}
      </template>
      <template v-slot:[`item.volume`]="{ item }">
        {{
          (item.volume ? item.volume : "-") +
          " / " +
          (item.variant ? item.variant : "-")
        }}
      </template>
      <template v-slot:[`item.client_name`]="{ item }">
        {{ item.client_name }} ({{ item.storer_name }})
      </template>
      <template v-slot:[`item.dimension`]="{ item }">
        {{
          (item.width ? item.width : "-") +
          " x " +
          (item.height ? item.height : "-") +
          " x " +
          (item.length ? item.length : "-")
        }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          class="ma-1"
          :color="item.status == 1 ? 'green' : 'red'"
          text-color="white"
        >
          {{ item.status == 1 ? "Active" : "Inactive" }}
        </v-chip>
      </template>
      <template v-slot:[`item.variant_sku_description`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-if="item.variant_sku_description.length > 80" v-on="on">{{
              item.variant_sku_description.slice(0, 80) + "..."
            }}</span>
            <span v-else>{{ item.variant_sku_description }}</span>
          </template>
          <span>{{ item.variant_sku_description }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="imagesFunction(item)" v-if="checkIcon(item)">
          <v-icon>mdi-image</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedItem: {},
      stores: [],
      total: 0,
      isloading: false,
      search: "",
      clients: [],
      options: {},
      client: null,
      result: [],
      sku: "",
      resultChild: [],
      dialog: false,
      infor_storer_id: "",
      images: [],

      headersChild: [
        {
          text: "Client (Storer)",
          value: "client_name",
          sortable: false,
          class: "body-1 font-weight-bold",
        },

        {
          text: "Warehouse",
          value: "warehouse_name",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "SKU Code",
          value: "sku_code",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "SKU Variant Code",
          value: "variant_sku_code",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Variant Description",
          value: "variant_sku_description",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Size / Design / Aroma",
          value: "size",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Volume / Variant",
          value: "volume",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "Color",
          value: "color",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "W x H x L (In cm)",
          value: "dimension",
          sortable: false,
          class: "body-1 font-weight-bold",
          width: "120px",
        },

        {
          text: "Weight (In gm)",
          value: "weight",
          sortable: false,
          class: "body-1 font-weight-bold",
        },

        {
          text: "Status",
          value: "status",
          sortable: false,
          class: "body-1 font-weight-bold",
        },

        {
          text: "Created (By)",
          value: "created_at",
          sortable: false,
          class: "body-1 font-weight-bold",
          width: 100,
        },

        {
          text: "Updated (By)",
          value: "updated_at",
          sortable: false,
          class: "body-1 font-weight-bold",
          width: 100,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
      ],
      headers: [
        { text: "Parent SKU", value: "SKU", sortable: false },
        { text: "SKU Description", value: "DESCR", sortable: false },

        { text: "Mapped Images", value: "images", sortable: false },
      ],
      image_mapping: [],
    };
  },
  watch: {
    options: {
      handler() {
        this.getlist();
      },
      deep: true,
    },
  },
  created() {
    if (this.$store.getters.user.user_category == 3) {
      this.fetchClientList();
    } else {
      if (this.$store.getters.user.user_category == 1) {
        this.getStores(this.$store.getters.user.id);
      }
    }
  },
  computed: {
    ...mapGetters(["userCategory"]),
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getSkuListBB",
      "fetchClient",
      "uploadReceipt",
      "getChannelDropdownBB",
      "getSkuListSearch",
      "getSkuImages",
    ]),
    checkIcon(item) {
      return this.image_mapping.includes(item.id);
    },
    imagesFunction(item) {
      this.selectedItem = item;
      let payload = {
        sku_variant_id: item.id,
        client_id: item.client_id,
      };
      this.getSkuImages(payload).then((res) => {
        if (res.data) {
          this.images = res.data.result;
          this.dialog = true;
        }
      });
    },
    fetchClientList() {
      if (this.clients.length) return;

      if (this.clients.length === 0) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          variant: 1,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getStores(id) {
      this.getChannelDropdownBB(id).then((res) => {
        this.stores = res.data;
      });
    },
    reset() {
      this.dialog = false;
      this.$refs.form.reset();
      this.file = null;
    },

    getlist() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.isloading = true;
      this.getSkuListSearch({
        sku_code: this.sku ? this.sku.trim() : this.sku,
        storer_id: this.infor_storer_id,
        client_id: this.client,
        ...this.options,
      })
        .then((res) => {
          this.result = res.data.records1;
          this.resultChild = res.data.records;
          this.total = res.data.total;
          this.isloading = false;
          this.image_mapping = res.data.image_mapping;

          if (this.result.length == 0 && this.resultChild.length == 0) {
            this.snackBar({ color: "error", message: "No Data Found" });
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
  },
};
</script>

<style scoped>
.elevation-1 {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}
.carousel-image {
  height: 100%;
  max-height: 200px;
  object-fit: contain;
  position: sticky;
  left: 0;
}

.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
